import React from "react";
import styled from "styled-components";
import { useLang } from "../i18n/LanguageContext";

export default function PricePicker({ value, onChange }) {
  const { t } = useLang();
  const mode = value.priceMode || "none";

  const modes = [
    { id: "tier", label: t("price.tier") },
    { id: "range", label: t("price.range") },
    { id: "from", label: t("price.from") },
    { id: "none", label: t("price.none") },
  ];

  const pick = (m) => {
    onChange("priceMode", m);
    if (m !== "tier") onChange("priceRange", "");
  };

  return (
    <Box>
      <Modes>
        {modes.map((m) => (
          <button type="button" key={m.id} className={mode === m.id ? "on" : ""} onClick={() => pick(m.id)}>
            {m.label}
          </button>
        ))}
      </Modes>

      {mode === "tier" && (
        <Tiers>
          {["€", "€€", "€€€"].map((s) => (
            <button type="button" key={s} className={value.priceRange === s ? "on" : ""} onClick={() => onChange("priceRange", s)}>
              {s}
            </button>
          ))}
        </Tiers>
      )}

      {mode === "range" && (
        <Inputs>
          <span>€</span>
          <input type="number" min="0" placeholder={t("price.min")} value={value.priceMin || ""} onChange={(e) => onChange("priceMin", e.target.value)} />
          <em>–</em>
          <span>€</span>
          <input type="number" min="0" placeholder={t("price.max")} value={value.priceMax || ""} onChange={(e) => onChange("priceMax", e.target.value)} />
        </Inputs>
      )}

      {mode === "from" && (
        <Inputs>
          <span>€</span>
          <input type="number" min="0" placeholder={t("price.amount")} value={value.priceFrom || ""} onChange={(e) => onChange("priceFrom", e.target.value)} />
        </Inputs>
      )}

      <Hint>{t("price.hint")}</Hint>
    </Box>
  );
}

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Modes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  button {
    font-family: inherit;
    font-size: 13px;
    padding: 9px 14px;
    border-radius: 100px;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.hair};
    background: transparent;
    color: ${({ theme }) => theme.colors.inkSoft};
    transition: 0.18s;
    &.on { background: ${({ theme }) => theme.colors.green}; color: ${({ theme }) => theme.colors.cream}; border-color: ${({ theme }) => theme.colors.green}; }
  }
`;

const Tiers = styled.div`
  display: flex;
  gap: 8px;
  button {
    flex: 1;
    font-family: inherit;
    font-size: 16px;
    padding: 11px;
    border-radius: 12px;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.hair};
    background: transparent;
    color: ${({ theme }) => theme.colors.green};
    &.on { background: ${({ theme }) => theme.colors.creamDeep}; border-color: ${({ theme }) => theme.colors.green}; font-weight: 600; }
  }
`;

const Inputs = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  span { color: ${({ theme }) => theme.colors.inkSoft}; }
  em { color: ${({ theme }) => theme.colors.inkSoft}; font-style: normal; }
  input {
    width: 120px;
    font-family: inherit;
    font-size: 15px;
    border: 1px solid ${({ theme }) => theme.colors.hair};
    border-radius: 10px;
    padding: 10px 12px;
    outline: none;
  }
`;

const Hint = styled.p`
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.inkSoft};
`;
